import React, { PropTypes } from 'react';
import { Link } from 'react-router';

import { link, transparentLink } from './styles.module.css';

/**
 * User menu presentational component, for logged out users.
 */
const UserMenuLoggedOut = ({ className, onLinkClick, transparent }) => (
  <div className={className}>
    <Link
      to="/login"
      onClick={onLinkClick}
      className={transparent ? transparentLink : link}
      data-tracking-link="signup-button"
      data-tracking-type="header"
    >
      Sign up or Log in
    </Link>
  </div>
);

UserMenuLoggedOut.propTypes = {
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * Function called on link click.
   */
  onLinkClick: PropTypes.func,
  /**
   * Boolean whether to use transparent styles.
   */
  transparent: PropTypes.bool,
};

UserMenuLoggedOut.defaultProps = {
  className: '',
  onLinkClick: () => {},
  transparent: false,
};

export default UserMenuLoggedOut;



// WEBPACK FOOTER //
// ./app/src/components/UserMenu/components/UserMenuLoggedOut/index.jsx